import { getProjectImage } from "@/data";
import type { Project } from "@/data";

type Props = {
  project: Project;
  onClose: () => void;
};

const ProjectModal = ({ project, onClose }: Props) => {
  const imageSrc = getProjectImage(project.id);

  return (
    <div
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-6"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg max-w-4xl w-full max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="relative w-full h-80 bg-[#F8FAFC]">
          <img
            src={imageSrc}
            alt={project.title}
            className="w-full h-full object-contain object-center"
          />
          <button
            onClick={onClose}
            className="absolute top-4 right-4 w-10 h-10 flex items-center justify-center rounded-full bg-white/90 hover:bg-white transition-colors cursor-pointer"
            aria-label="Close"
          >
            <span className="text-2xl leading-none text-gray-900">×</span>
          </button>
        </div>

        <div className="p-10">
          <div className="flex items-center justify-between mb-6">
            <span className="text-sm font-medium text-[#0D9488]">
              {project.target}
            </span>
            {project.year && <span className="text-sm text-gray-500">{project.year}</span>}
          </div>

          <h2 className="text-3xl font-bold text-gray-900 mb-4">{project.title}</h2>

          <div className="flex flex-wrap gap-2 mb-8">
            {project.tags.map((tag, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-[#F0FDFA] text-xs font-medium text-[#0F766E] rounded-full"
              >
                {tag}
              </span>
            ))}
          </div>

          <div className="space-y-8">
            <Section title="배경 / 목표" body={project.background} />
            <Section title="문제 정의" body={project.problem} />
            <Section title="접근 방법 및 해결" body={project.solution} />

            <div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">적용 기술</h3>
              <div className="flex flex-wrap gap-2">
                {project.tech.map((tech, index) => (
                  <span
                    key={index}
                    className="px-4 py-2 bg-[#F0FDFA] text-sm font-medium text-[#0F766E] rounded-lg border border-[#99F6E4]/30"
                  >
                    {tech}
                  </span>
                ))}
              </div>
            </div>

            <Section title="성과" body={project.outcome} />
          </div>
        </div>
      </div>
    </div>
  );
};

type SectionProps = {
  title: string;
  body: string;
};

const Section = ({ title, body }: SectionProps) => (
  <div>
    <h3 className="text-lg font-bold text-gray-900 mb-3">{title}</h3>
    <p className="text-sm text-gray-600 leading-relaxed">{body}</p>
  </div>
);

export default ProjectModal;
